import { useGetUser } from '@/hooks/useGetUser';
import { convertValueToString } from '@/pages/dashboard/components/helpers/utils';
import { formatAmount } from '@/utils/helpers/general';
import { formatCurrency } from '@/utils/currency';

const useFormatNumber = () => {
  const { company } = useGetUser();

  return (
    value: number | string,
    withCurrency?: boolean,
    decimalOverride?: number,
    abbreviate?: boolean,
  ): string => {
    const numberValue = typeof value === 'string' ? parseFloat(value) : value;

    if (Number.isNaN(numberValue)) {
      return 'Invalid value';
    }

    if (abbreviate && numberValue > 999999) {
      return convertValueToString(numberValue);
    }

    if (withCurrency && company?.settings?.currency) {
      return formatCurrency(numberValue, company.settings.currency);
    }

    const { settings: { decimalSeparator = '.', thousandSeparator = ',', decimals = 2 } = {} } =
      company || {};

    const finalDecimals = typeof decimalOverride === 'number' ? decimalOverride : decimals;

    return formatAmount(numberValue, decimalSeparator, thousandSeparator, finalDecimals);
  };
};

export default useFormatNumber;
